import { render } from "./open-booking-detail.template.html?vue&type=template&id=7447c3a2&scoped=true"
import script from "./OpenBookingDetail.vue?vue&type=script&lang=ts"
export * from "./OpenBookingDetail.vue?vue&type=script&lang=ts"

import "./OpenBookingDetail.vue?vue&type=style&index=0&id=7447c3a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7447c3a2"

export default script